module.exports = __webpack_public_path__ + "img/art-work-icon8.926bc94f.png";